
export default (result) => {
    if (Array.isArray(result)) {
        return result.reduce((acc, a) =>
            ({ ...acc, ...a }), {},
        );
    }
    return result;
};



/** WEBPACK FOOTER **
 ** ./src/utils/mergeArray.js
 **/